class NonPartiallyConstructible {
    _nonPartiallyConstructibleMarker() { }
}
export class Point {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
}
//# sourceMappingURL=utils.js.map